<template>
  <div class="flex gap-1">
    <router-link to="/settings/company/advertising">
      <div
        v-for="source in leadSourceData"
        class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800 mr-2"
      >
        {{ source.value }}
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    contact: {
      required: true,
      type: Object,
    },
  },
  computed: {
    leadSourceData() {
      const ap = this.contact.attribution_params || this.contact.attributionParams;

      if (!ap || ap == {}) return [];

      return Object.keys(ap).map(key => {
        return {
          type: key,
          value: ap[key],
        };
      });
    },
  },
};
</script>
